
import { Input } from "@/components/ui/input";
import { useLanguage } from "@/contexts/LanguageContext";

interface ProfileFormProps {
  profile: {
    id: string;
    full_name: string;
    email: string;
    phone_number: string | null;
  };
  onProfileChange: (profile: any) => void;
  saving: boolean;
}

export const ProfileForm = ({ profile, onProfileChange, saving }: ProfileFormProps) => {
  const { t } = useLanguage();
  
  return (
    <div className="space-y-0">
      <div className="flex max-w-[480px] flex-wrap items-end gap-4 px-4 py-3">
        <label className="flex flex-col min-w-40 flex-1">
          <p className="text-[#111418] text-base font-medium leading-normal pb-2">
            {t('profile.full_name')}
          </p>
          <Input
            value={profile.full_name}
            onChange={(e) => onProfileChange({ ...profile, full_name: e.target.value })}
            disabled={saving}
            className="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-lg text-[#111418] focus:outline-0 focus:ring-0 border border-[#dce0e5] bg-white focus:border-[#dce0e5] h-14 placeholder:text-[#637588] p-[15px] text-base font-normal leading-normal"
          />
        </label>
      </div>

      <div className="flex max-w-[480px] flex-wrap items-end gap-4 px-4 py-3">
        <label className="flex flex-col min-w-40 flex-1">
          <p className="text-[#111418] text-base font-medium leading-normal pb-2">
            {t('profile.email')}
          </p>
          <Input
            type="email"
            value={profile.email}
            onChange={(e) => onProfileChange({ ...profile, email: e.target.value })}
            disabled={saving}
            className="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-lg text-[#111418] focus:outline-0 focus:ring-0 border border-[#dce0e5] bg-white focus:border-[#dce0e5] h-14 placeholder:text-[#637588] p-[15px] text-base font-normal leading-normal"
          />
        </label>
      </div>

      <div className="flex max-w-[480px] flex-wrap items-end gap-4 px-4 py-3">
        <label className="flex flex-col min-w-40 flex-1">
          <p className="text-[#111418] text-base font-medium leading-normal pb-2">
            {t('profile.phone')}
          </p>
          <Input
            type="tel"
            value={profile.phone_number || ''}
            onChange={(e) => onProfileChange({ ...profile, phone_number: e.target.value })}
            placeholder={t('profile.phone_placeholder')}
            disabled={saving}
            className="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-lg text-[#111418] focus:outline-0 focus:ring-0 border border-[#dce0e5] bg-white focus:border-[#dce0e5] h-14 placeholder:text-[#637588] p-[15px] text-base font-normal leading-normal"
          />
        </label>
      </div>
    </div>
  );
};
